(function (root, factory) {
    if (typeof define === "function" && define.amd) {
        define("pr360Viewer", factory(root));
    } else if (typeof exports === "object") {
        module.exports = factory(root);
    } else {
        root.pr360Viewer = factory(root);
    }
})(window || this, function (root) {

    "use strict";

    /**
     * Variables
     */

    const pr360Viewer = {};

    let panoramaContainer = undefined,
        rootEl = undefined;

    let closePanoramaContainer = undefined,
        savePanoramaContainer = undefined,
        loadingPanoramaContainer = undefined;

    let panorama = null,
        viewer = null,
        attachedElement = null;

    let onSave = null;

    const initElements = (options) => {
        panoramaContainer = document.querySelector('#panorama-container');
        rootEl = panoramaContainer.closest('.pr360viewer');

        if (hasRoot()) {
            closePanoramaContainer = rootEl.querySelector('.js-panorama-close');
            savePanoramaContainer = rootEl.querySelector('.js-panorama-save');
            loadingPanoramaContainer = rootEl.querySelector('.js-panorama-loading');
        }

        if (hasCloseButton()) {
            closePanoramaContainer.addEventListener('click', () => {
                pr360Viewer.close();
            });
        }

        if (hasSaveButton()) {
            options.renderer = new THREE.WebGLRenderer({
                alpha: true,
                antialias: false,
                preserveDrawingBuffer: true
            });

            savePanoramaContainer.addEventListener('click', onSaveButtonClick);
        }

        let movement = {
            enableZoom: true,
            maxZoomOut: 70, //120 je max hodnota, pri ktere fotka vypada jako fisheye
            maxZoomIn: 30,
            //Jak moc se muzeme divat do stran
            //pokud false tak se nepouzije, jinak [min, max] kde: -PI <= min < max <= PI
            verticalAngle: false
        };

        if (options.movement !== undefined) {
            movement = Object.assign(options.movement, movement);
            delete options.movement;
        }

        options.horizontalView = false; //true - zakaze pohyb nahoru a dolu

        return {options: options, movement: movement};
    };

    pr360Viewer.createViewer = (elementId, options) => {
        if (options === undefined)
            options = {};

        let settings = initElements(options);
        options = Object.assign({container: document.getElementById(elementId)}, settings.options);

        viewer = new PANOLENS.Viewer(options);
        viewer.OrbitControls.noZoom = !settings.movement.enableZoom;
        viewer.OrbitControls.maxFov = settings.movement.maxZoomOut;
        viewer.OrbitControls.minFov = settings.movement.maxZoomIn;

        if (settings.movement.verticalAngle !== false)
            setVerticalAngleRestrictions(settings.movement.verticalAngle[0], settings.movement.verticalAngle[1]);
    };

    pr360Viewer.setVerticalAngleRestrictions = function (min, max) {
        if (min > max) {
            console.error('min angle > max angle');
            return;
        }

        if (min < -Math.PI || max > Math.PI) {
            console.error('min,  max angle out of range -PI <= min < max <= PI');
            return;
        }

        viewer.OrbitControls.minAzimuthAngle = min;
        viewer.OrbitControls.maxAzimuthAngle = max;
    };

    const setAttachedElement = (el) => {
        attachedElement = el;
    };

    pr360Viewer.getInitialViewByElement = (el) => {
        if (el === undefined)
            throw 'Element is not defined';

        let x = el.dataStorage.panoviewX;
        let y = el.dataStorage.panoviewY;
        let z = el.dataStorage.panoviewZ;

        if (x !== undefined && y !== undefined && z !== undefined)
            return {x: x,y: y,z: z};

        return null;
    };

    pr360Viewer.getVerticalAngleByElement = (el) => {
        if (el === undefined)
            throw 'Element is not defined';

        let min = el.dataStorage.panoviewVerticalMin;
        let max = el.dataStorage.panoviewVerticalMax;

        if (min !== undefined && max !== undefined)
            return {min: min, max: max};

        return null;
    };

    pr360Viewer.addPanorama = (el) => {
        try {
            pr360Viewer.addPanoramaByElement(el);
        } catch (e) {
            console.error(e);
        }
    };

    pr360Viewer.addPanoramaByImageSource = (source, data) => {
        try {
            let img = document.createElement('img');
            img.src = source;
            img.dataStorage = {};

            if (hasSaveButton())
                img.dataStorage.panofilepath = source;

            if (data !== undefined) {
                if (data.view !== undefined) {
                    img.dataStorage.panoviewX = data.view.x;
                    img.dataStorage.panoviewY = data.view.y;
                    img.dataStorage.panoviewZ = data.view.z;
                }

                if (data.verticalAngle !== undefined) {
                    img.dataStorage.panoviewVerticalMin = data.verticalAngle.min;
                    img.dataStorage.panoviewVerticalMax = data.verticalAngle.max;
                }
            }

            pr360Viewer.addPanoramaByElement(img, true);
        } catch (e) {
            console.error(e);
        }
    };

    pr360Viewer.addPanoramaByElement = (el, fromSource) => {
        fromSource = fromSource === undefined ? false : fromSource;

        if (viewer === null)
            throw 'Create viewer first by calling createViewer.';

        if (el === undefined)
            throw 'Element is not defined';

        setAttachedElement(el);

        if (fromSource) {
            panorama = pr360Viewer.createPanorama(el);
        } else {
            panorama = pr360Viewer.createPanorama(el.dataStorage.panofilepath);
        }

        viewer.add(panorama);
        panoramaContainer.classList.add('open');

        let initialView = pr360Viewer.getInitialViewByElement(el);
        if (initialView !== null) {
            viewer.getCamera().position.set(initialView.x, initialView.y, initialView.z);
        } else {
            viewer.getCamera().position.set(200, 0, 1);
        }

        let verticalAngle = pr360Viewer.getVerticalAngleByElement(el);
        if (verticalAngle !== null)
            pr360Viewer.setVerticalAngleRestrictions(verticalAngle.min, verticalAngle.max);

        viewer.getControl().update();
    };

    pr360Viewer.createPanorama = (path) => {
        if (path === undefined || path === '')
            throw 'Undefined or empty path to file "data-panofilepath" or it is not valid image element';

        return new PANOLENS.ImagePanorama(path);
    };

    pr360Viewer.close = () => {
        if (panorama !== null) {
            panorama.dispose();
            viewer.remove(panorama);
            panorama = null;
            attachedElement = null;
        }
        panoramaContainer.classList.remove('open');

        if (hasLoadingState())
            loadingPanoramaContainer.style.display = 'none';
    };

    pr360Viewer.callback = (type, func) => {
        if (type === 'save')
            onSave = func;
    };

    const onSaveButtonClick = (ev) => {
        ev.preventDefault();

        let promise = false;
        if (viewer !== null && onSave !== null) {
            let canvas = viewer.getRenderer().domElement;
            let camera = viewer.getCamera();

            attachedElement.dataStorage.panoviewX = camera.position.x;
            attachedElement.dataStorage.panoviewY = camera.position.y;
            attachedElement.dataStorage.panoviewZ = camera.position.z;

            if (hasLoadingState())
                loadingPanoramaContainer.style.display = 'block';

            promise = onSave(canvas.toDataURL(), attachedElement, {x: camera.position.x, y: camera.position.y, z: camera.position.z});
        }

        if (promise !== undefined && promise) {
            if (promise.always !== undefined) {
                promise.always(function (data) {
                    pr360Viewer.close();
                });
            } else {
                pr360Viewer.close();
            }
        }

        return false;
    };

    const hasRoot = () => {
        return rootEl !== undefined && rootEl !== null;
    };

    const hasSaveButton = () => {
        return savePanoramaContainer !== undefined && savePanoramaContainer !== null;
    };

    const hasLoadingState = () => {
        return loadingPanoramaContainer !== undefined && loadingPanoramaContainer !== null;
    };

    const hasCloseButton = () => {
        return closePanoramaContainer !== undefined && closePanoramaContainer !== null;
    }

    return pr360Viewer;
});